import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const aboutContent = {
    title: 'Hakkımızda',
    subtitle: 'Isparta\'da hukuki danışmanlık alanında güvenilir hizmet',
    content: 'Yıldız & Başyiğit Hukuk ve Danışmanlık olarak, 4+ yıllık deneyimimizle müvekkillerimize en kaliteli hukuki hizmeti sunmayı hedefliyoruz. Uzman kadromuz ile ticaret, gayrimenkul, iş hukuku ve birçok alanda profesyonel çözümler üretiyoruz.',
    stats: [
      { number: '4+', label: 'Yıl Deneyim' },
      { number: '500+', label: 'Başarılı Dava' },
      { number: '100+', label: 'Mutlu Müvekkil' }
    ]
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="animate-slide-in-left">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 font-poppins">
              {aboutContent.title}
            </h2>
            <div className="w-16 h-0.5 bg-slate-900 mb-6"></div>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed font-poppins font-light">
              {aboutContent.subtitle}
            </p>
            <p className="text-slate-600 mb-8 leading-relaxed font-poppins font-light">
              {aboutContent.content}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/about">
                <Button variant="primary">
                  Daha Fazla Bilgi
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline">
                  İletişime Geçin
                </Button>
              </Link>
            </div>
          </div>
          
          <div className="animate-slide-in-right">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/6b8567ebb346aeb6bc2756cdbb8df24b.jpg"
                alt="Hukuk bürosu"
                className="rounded-lg shadow-lg object-cover object-top w-full h-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent rounded-lg"></div>
            </div>
            
            <div className="grid grid-cols-3 gap-6 mt-8">
              {aboutContent.stats.map((stat, index) => (
                <div 
                  key={index} 
                  className="text-center animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="text-3xl font-bold text-slate-900 mb-2 font-poppins">
                    {stat.number}
                  </div>
                  <div className="text-slate-600 text-sm font-poppins font-light">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
